export default __webpack_public_path__ + "static/media/MinnieNormal.bc826c58.jpg";